import { ProductDurationType, type Product } from "@fitness-app/data-models/entities/Product";

import { type ProductFormModel } from "~/modules/Products/ProductForm/types";

/** Maps the two duration fields of the product form onto the shape the backend validates. */
export const getProductDuration = (
  type: ProductFormModel["productDurationType"],
  duration: ProductFormModel["productDuration"],
): Product["productDuration"] => {
  if (!type) {
    return null;
  }

  if (type === ProductDurationType.Infinite) {
    return { type: ProductDurationType.Infinite };
  }

  if (type === ProductDurationType.UntilDate && duration && "untilDate" in duration) {
    return {
      type: ProductDurationType.UntilDate,
      // Store a timezone-agnostic calendar day; the backend resolves it to the end
      // of that day in the business timezone so access lasts through the whole day
      // (instead of being cut at 00:00) regardless of the admin's timezone.
      date: duration.untilDate.format("YYYY-MM-DD"),
    };
  }

  if (type === ProductDurationType.LastsFor && duration && "count" in duration) {
    return {
      type: ProductDurationType.LastsFor,
      // An untouched unit select leaves the field empty; the backend only accepts
      // month or week, so fall back to the unit the form displays by default.
      unit: duration.unit ?? "month",
      count: duration.count,
    };
  }

  return null;
};
